import { render, staticRenderFns } from "./TripleActivation.vue?vue&type=template&id=7c63114b&"
import script from "./TripleActivation.vue?vue&type=script&lang=js&"
export * from "./TripleActivation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports